export const resetPassportSession = () => {
    const returnPath = encodeURIComponent(window.location.href);
    window.location.href = `https://passport.yandex-team.ru/auth/?from=vzhik&retpath=${returnPath}`;
};
